import {
  CheckoutAvailabilityService,
  FinancingService,
  NotificationService,
  SettingsService,
  ShoppingCartService,
  ShoppingListService,
  TranslationsService,
  ZipValidationService,
  PlatformService,
  ProductService,
  CookieConsentService,
  StoreService,
  VpcService,
} from '@inter-ikea-kompis/services';
import {
  getShoppingListServiceOptions,
  getShoppingCartServiceOptions,
  getFrequentlyUsedServiceSettingsOptions,
  translationSettings,
  applicationSettings,
} from '../settings/application';

const serviceNames = {
  NotificationService: 'NotificationService',
  SettingsService: 'SettingsService',
  ZipValidationService: 'ZipValidationService',
  ShoppingListService: 'ShoppingListService',
  ShoppingCartService: 'ShoppingCartService',
  CheckoutAvailabilityService: 'CheckoutAvailabilityService',
  FinancingService: 'FinancingService',
  TranslationService: 'TranslationService',
  PlatformService: 'PlatformService',
  ProductService: 'ProductService',
  CookieConsentService: 'CookieConsentService',
  StoreService: 'StoreService',
  VpcService: 'VpcService',
};

const services: { [key: string]: object } = {};

const serviceStarter = (serviceName: string, service: any, args: object) => {
  if (services[serviceName]) return services[serviceName];

  const newService = new service(args);
  services[serviceName] = new service(args);
  return newService;
};

export const getDexfSettingsService = () => {
  const { dexfApiKey, dexfEnvironment, dexfApplicationId, locale } =
    getFrequentlyUsedServiceSettingsOptions();
  return serviceStarter(serviceNames.SettingsService, SettingsService, {
    dexfApiKey,
    dexfEnvironment,
    dexfApplicationId,
    locale,
  });
};

export const getNotificationService = () => {
  return serviceStarter(
    serviceNames.NotificationService,
    NotificationService,
    getFrequentlyUsedServiceSettingsOptions()
  );
};

export const getZipValidationService = () => {
  return serviceStarter(
    serviceNames.ZipValidationService,
    ZipValidationService,
    getFrequentlyUsedServiceSettingsOptions()
  );
};

export const getShoppingListService = () => {
  return serviceStarter(
    serviceNames.ShoppingListService,
    ShoppingListService,
    getShoppingListServiceOptions()
  );
};

export const getShoppingCartService = () => {
  return serviceStarter(
    serviceNames.ShoppingCartService,
    ShoppingCartService,
    getShoppingCartServiceOptions()
  );
};

export const getCheckoutAvailabilityService = () => {
  return serviceStarter(
    serviceNames.CheckoutAvailabilityService,
    CheckoutAvailabilityService,
    getFrequentlyUsedServiceSettingsOptions()
  );
};

export const getFinancingService = () => {
  return serviceStarter(serviceNames.FinancingService, FinancingService, {
    settings: getFrequentlyUsedServiceSettingsOptions().settings,
  });
};

export const getTranslationsService = () => {
  return serviceStarter(
    serviceNames.TranslationService,
    TranslationsService,
    translationSettings
  );
};

export const getPlatformService = () => {
  return serviceStarter(serviceNames.PlatformService, PlatformService, {
    applicationName: applicationSettings.applicationName,
    settings: getFrequentlyUsedServiceSettingsOptions().settings,
  });
};

export const getProductService = () => {
  return serviceStarter(
    serviceNames.ProductService,
    ProductService,
    getFrequentlyUsedServiceSettingsOptions()
  );
};

export const getCookieConsentService = () => {
  return serviceStarter(
    serviceNames.CookieConsentService,
    CookieConsentService,
    getFrequentlyUsedServiceSettingsOptions()
  );
};

export const getStoreService = () => {
  return serviceStarter(
    serviceNames.StoreService,
    StoreService,
    getFrequentlyUsedServiceSettingsOptions()
  );
};

export const getVpcService = () => {
  const { dexfApiKey, settings } = getFrequentlyUsedServiceSettingsOptions();
  const {
    applicationName,
    dexfVpcConfigurationVersion: dexfConfigurationVersion,
  } = applicationSettings;
  return serviceStarter(serviceNames.VpcService, VpcService, {
    dexfApiKey,
    applicationName,
    dexfConfigurationVersion,
    settings,
  });
};
